import { IUser } from 'app/models/user'

const getDisplayName = (user: IUser) => {
  const middlename = user.middlename !== null && `${user.middlename}`.trim().length > 0 ? user.middlename + ' ' : ''
  let displayName = `${user.firstname !== null ? user.firstname : ''} ${middlename}${
    user.surname !== null ? user.surname : ''
  }`.trim()

  if (displayName.length === 0) {
    displayName = user.email
  }

  return displayName
}

export default getDisplayName
